
<app-ramadan2022-header></app-ramadan2022-header>
<div class="ramadan2022-banner">
  <img src="assets/img/ramadan2022/ramadan-banner.jpg" class="img-responsive hidden-xs" >
  <img src="assets/img/ramadan2022/megabannermobile.jpg" class="img-responsive hidden-lg hidden-md hidden-sm" >

</div>
<div class="ramadan-bg-container1">
<div class="overlay"></div>
  <div class="content">
    <router-outlet></router-outlet>

  </div>
</div>
<app-ramadan2022-footer></app-ramadan2022-footer>
